import '../../../assets/styles/styles.css';
import '../lobby.css';

import React, { useState, useEffect } from 'react';
import {session} from '../../../utils/nakama';
import copy from 'copy-to-clipboard';
import { QRCodeSVG } from 'qrcode.react';
import EmailIcon from '@mui/icons-material/Email';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import QrCodeIcon from '@mui/icons-material/QrCode';
import { isLocal } from '../../../constants';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Grid,
  } from '@mui/material';



import { Offcanvas, Row, Col } from 'react-bootstrap';

export default function InviteNav(props) {
    const [inviteByLink, setInviteByLink] = useState(null);
    const [qrOpen, setQrOpen] = useState(false);
    const [dispName, setDispName] = useState('');
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('xl'));
    
    
    useEffect(() => {
        const getUserAndSetLink = async () => {
          try {
            if (session) {
                const userId = session.user_id;
    
                if (userId) {
                    const link = isLocal
                    ? `http://localhost:3001/auth?invitedBy=${userId}`
                    : `https://zoombies.world/auth?invitedBy=${userId}`;
    
                    setInviteByLink(link);
                }
            }
          } catch (error) {
            console.error('Failed to set invite by link', error);
          }
        };
        displayNameSetter();
        getUserAndSetLink();
      }, []);

        const copyFriendsInviteLink = async () => {
            if (inviteByLink) {
                const success = copy(inviteByLink);
                if (success) {
                    toast.success('Invite link copied to clipboard!', {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            }
        }

        const handleQrOpen = () => {
            setQrOpen(true);
        };

        const handleQrClose = () => {
            setQrOpen(false);
        };

        
        const emailInviteHandler = async () => {
            window.open(
            `mailto:?subject=Join%20my%20tribe%20in%20Zoombies%20World%20!&body=Join%20now!%20${inviteByLink}`,
            '_blank'
            );
        };

        const displayNameSetter = async () => {
            if (session && session.username) {
                setDispName(session.username);
            }
          };
    

    return (
        <Offcanvas show={props.isInviteBarActive} onHide={() => props.setIsInviteBarActive(false)}  placement="end" style={{ backgroundColor: '#1B3A5D' }}>
            <>
                <ToastContainer />
            </>
            <Modal fullScreen={fullScreen} open={qrOpen} onClose={handleQrClose} className="qr-modal">
                <div className="qr-container" onClick={handleQrClose}>
                    <div>
                    <img
                        src="https://zoombies.world/images/zoombies_logo_horizontal_white.png"
                        className="qr-logo"
                        alt='QR code'
                    />
                    </div>
                    <p />
                    <p />
                    <p />
                    <div className="qr-code-text">
                        Scan to Join {dispName}&apos;s Tribe in the
                        <br />
                        Zoombies World
                    </div>
                    <div className="qr-code">
                        <QRCodeSVG
                        value={inviteByLink}
                        size={256}
                        level={'M'}
                        bgColor={'#ffffff'}
                        fgColor={'#000000'}
                        />
                    </div>
                </div>
            </Modal>
            <Offcanvas.Header className="offcanvas-header-container info" closeButton style={{ justifyContent: 'center' }}>
                <Offcanvas.Title
                    className="invite-nav-title"
                    style={{
                        display: 'flex',
                        fontFamily: 'Truculenta, sans-serif',
                        fontWeight: 'bold',
                        color: '#B2F1FF',
                        justifyContent: 'center',
                        alignContent: 'center',
                        textAlign: 'center',
                    }}
                >
                    Friends in your Tribe can send you Bonez for FREE every day!
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="offcanvas-body-container info">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "8%", marginBottom: "6%" }}>
                    <button className="button invite" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} onClick={copyFriendsInviteLink}>
                        <img src="https://zoombies.world/images/dapp/blue_button_400.webp" alt="" width="180%" height="auto" />
                        <span className="invite-button-text" style={{ fontSize: "22px" }}>Copy Your Invite Link</span>
                    </button>
                </div>
                <Grid container spacing={3} style={{ padding: '0 16px' }}>
                    <Grid className="icon-griditem" item xs={4}>
                        <div className="share-icon-btn" onClick={emailInviteHandler}>
                            <EmailIcon sx={{ fontSize: 36 }} />
                            <span className="share-icon-label">Email</span>
                        </div>
                    </Grid>
                    <Grid className="icon-griditem" item xs={4}>
                        <a
                            target="_blank"
                            className="share-icon-btn"
                            href={`https://twitter.com/share?text=Join%20my%20tribe%20in%20Zoombies%20World&url=${inviteByLink}`}
                            rel="noreferrer"
                        >
                            <TwitterIcon sx={{ fontSize: 36 }} />
                            <span className="share-icon-label">Twitter</span>
                        </a>
                    </Grid>
                    <Grid className="icon-griditem" item xs={4}>
                        <a
                            target="_blank"
                            href={`https://www.facebook.com/sharer/sharer.php?u=${inviteByLink}&amp;src=sdkpreparse`}
                            rel="noopener noreferrer"
                            className="share-icon-btn"
                        >
                            <FacebookIcon sx={{ fontSize: 36 }} />
                            <span className="share-icon-label">Facebook</span>
                        </a>
                    </Grid>
                    <Grid className="icon-griditem" item xs={4}>
                        <a
                            target="_blank"
                            href={`https://telegram.me/share/url?url=${inviteByLink}&text=Join%20my%20tribe%20in%20Zoombies%20World`}
                            rel="noopener noreferrer"
                            className="share-icon-btn"
                        >
                            <TelegramIcon sx={{ fontSize: 36 }} />
                            <span className="share-icon-label">Telegram</span>
                        </a>
                    </Grid>
                    <Grid className="icon-griditem" item xs={4}>
                        <a
                            target="_blank"
                            href={`https://www.linkedin.com/sharing/share-offsite/?url=${inviteByLink}`}
                            rel="noopener noreferrer"
                            className="share-icon-btn"
                        >
                            <LinkedInIcon sx={{ fontSize: 36 }} />
                            <span className="share-icon-label">LinkedIn</span>
                        </a>
                    </Grid>
                    <Grid className="icon-griditem" item xs={4}>
                        <a
                            target="_blank"
                            href={`https://wa.me/?text=Join%20my%20tribe%20in%20Zoombies%20World%20${inviteByLink}`}
                            rel="noopener noreferrer"
                            className="share-icon-btn"
                        >
                            <WhatsAppIcon sx={{ fontSize: 36 }} />
                            <span className="share-icon-label">WhatsApp</span>
                        </a>
                    </Grid>
                    <Grid className="icon-griditem" item xs={12}>
                        <div className="share-icon-btn" onClick={handleQrOpen}>
                            <QrCodeIcon sx={{ fontSize: 36 }} />
                            <span className="share-icon-label">Show QR Code</span>
                        </div>
                    </Grid>
                </Grid>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "15%", marginBottom: "15%" }}>
                    <button className="button invite" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} 
                    onClick={() => {
                            const link = isLocal
                            ? `http://localhost:3001/auth/friends`
                            : `https://zoombies.world/auth/friends`;
                            window.location.href = link
                        }}>
                        <img src="https://zoombies.world/images/dapp/green_button_400.webp" alt="" width="180%" height="auto" />
                        <span className="invite-button-text" style={{ fontSize: "22px" }}>View My Tribe</span>
                    </button>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}